/*
 * @Author: wsx
 * @Date: 2022-01-18 15:51:49
 * @LastEditTime: 2022-01-18 15:55:22
 * @LastEditors: your name
 * @Description:
 */
/**
 * 删除form中值为("", null, undefined)的key
 * @param {object} form
 */
const formatForm = form => {
  const arr = ["", null, undefined, 'Invalid date'];
  for (const i in form) {
    if (arr.includes(form[i])) {
      Reflect.deleteProperty(form, i);
    }
  }
  return form;
};
const formatFormNumber = (form, arr) => {
  for (const i in form) {
    if (arr.includes(i) && form[i].toString().indexOf("*") !== -1) {
      Reflect.deleteProperty(form, i);
    }
  }
  return form;
};
export { formatForm, formatFormNumber };